import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, fromEvent, Observable, of, Subject, Subscription } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { Filter } from 'src/app/interfaces/filter';
import { HTTPService } from 'src/app/services/http.service';
import { FilterviewComponent } from './filterview/filterview.component';
import {ObjectUtil} from '../../system-utils/utils/ObjectUtil'
import { UserConfigServices } from 'src/app/services/user-config.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { DialogService } from 'src/app/services/dialog.service';
import { SalvarfiltroComponent } from './salvarfiltro/salvarfiltro.component';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { PromptFilterViewComponent } from '../prompt-filter-view/prompt-filter-view.component';
import { action } from 'src/app/interfaces/action';
import { PermissionServices } from 'src/app/services/permission.services';
import { CopyFormConfigurationComponent } from '../formview/copy-form-configuration/copy-form-configuration.component';
import { ThemeService } from 'src/app/services/theme.service';

export interface FastFilter{
    name:string;
    fieldName?:string;
    checked:string[];
    conditions:FastFilterItens[];
    
}

export interface FastFilterItens{
    name:string;
    icon?:string;
    svgIcon?:string;
    id:string;
    condition:string;
}

export interface ColumnsExpressFilter{
      name:string;
      desc:string;
}

@Component({
    selector: 'gridview',
    templateUrl: './gridview.component.html',
    styleUrls: ['./gridview.component.scss'],
    standalone: false
})
export class GridviewComponent implements OnInit, OnDestroy, AfterViewInit {

  sub1:Subscription;
  sub6:Subscription;
  @ViewChild(FilterviewComponent) filterViewComponent: FilterviewComponent;
  @ViewChild('carddetail',{read:ViewContainerRef}) container: ViewContainerRef;
  @Output() rowContext: EventEmitter<any> = new EventEmitter();

  /** filtros salvos selecionados (substitui o ViewChild de MatSelect) */
  filterSelect = new UntypedFormControl([]);
  compareFilter = (a: Filter, b: Filter): boolean => a && b && a.name === b.name;

  /** spinners NG-ZORRO (substituem os ngx-spinner "gridview" e "gridviewitem") */
  screenLoading = false;
  itemsLoading = false;

  i:number = 0;
  showAction:boolean = false;
  actionList:action[] = [];
  fieldSelected:string[] = [];
  public contextmenuColumn: any;
  public rows: BehaviorSubject<CardView[]> = new BehaviorSubject<CardView[]>([]);
  public temp:BehaviorSubject<CardView[]> = new BehaviorSubject<CardView[]>([]);
  public rawEvent: any;
  filterExpression = "";
  selectedValue: string;
  filters:Filter[];
  showFilter = false;
  dataRowColumns:columnsDef[] = [];
  currentPage:number = 0;  
  userConfig:{pagesize:number, lastFilter:string[], lastFastFilter:{name:string,filter:string[]}[]  }
  height:string = "60%";
  heightFilter:string = "25%";
  totalLines: number = -1;
  public filtroStr:String = "Nenhum campo selecionada para filtro."
  opened = false;
  showPaginator = false;
  lastFilter:Object;
  init:boolean = false;
  pageControl:number[] = [];
  @Input() name:string;
  @Input() tableName:string;
  @Input() title:string = "";
  @Input() pk:string = "";
  @Input() img:string = "";
  @Input() columns:ColumnsExpressFilter[]= [];
  @Input() options:Object[] = [];
  @Input() cardcustom:any;
  @Input() cardsubtitle:any;
  @Input() addButtonAction:Function = null;
  @Input() canInsert:boolean = false;
  @Input() canEdit:boolean = false;
  @Input() config:{value:string, columnName:string, fontName:string, fontSize:string, fontWeight:string, row:number,column:number,descName:string, fontColor:string}[]
  @Input() fastFilter:FastFilter[] =[];
  cancelPaginator = false;
  inputEnable = false;
  emoji = '&#128546;';
  
  
  sub3:Subscription;
  sub4:Subscription;
  inputValue: string;
  editing: Filter;
  expanded: boolean = false;
  

  constructor(private http:HTTPService,private cd:ChangeDetectorRef,private snackBar:SnackbarService, private ucs:UserConfigServices, private uas:UserAuthenticationServices, private dialogServices:DialogService,
    private ap:PermissionServices,
    private componentFactoryResolver: ComponentFactoryResolver,
    public ThemeService:ThemeService) {
        this.userConfig = {pagesize: 5, lastFilter: [], lastFastFilter:[]};
        
  }
  
  addButtonActionClick(evento,userConfig){
      this.addButtonAction(evento,userConfig);
  }


  ngOnDestroy(): void {
    if ( this.sub1 != null){this.sub1.unsubscribe()};
    if ( this.sub3 != null){this.sub3.unsubscribe()};
    if ( this.sub4 != null){this.sub4.unsubscribe()};
    if ( this.sub6 != null){this.sub6.unsubscribe()};
    this.cancelPaginator = true;
    this.cd.detach();
  }

  addComponent(){
    
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.cardcustom.elementRef.nativeElement);
        
    //let component = this.vwc.createComponent(componentFactory);
    let component = this.container.createComponent(componentFactory);
    this.cd.detectChanges();     
    
  }


  trackByFn(index, item) {
    return item.pk;
  }

  apply(currentPage:number, event?, functions?:Function[],condition?:string , showSpinner:boolean = true){


    return  new Promise(async (resolve,reject)=>{
      if ( showSpinner && this.init){
        this.screenLoading = true;
      }
      
      if ( !this.init && currentPage==0){
        this.itemsLoading = true;
      }
      

      let currentTotalLine = this.rows.getValue().length;
      
      let limit = 100;
      if ( currentTotalLine <= 500 ){
        limit = 100;
      }else if ( currentTotalLine > 500 && currentTotalLine<= 5000 ){
          limit = 500;
      }else if ( currentTotalLine >5000 ) {
          limit = 5000;
      }
      
      let ob= {
            "entityName":this.tableName,
            "rows":limit,
            "showPresentation":true,
            "showRelationshipData":false,
            "showRelationship":false,
            "fetchSize":currentPage,
            "condition":condition
        } 
  
        this.sub1 =  this.http.post(ob,"JsonBrokerServices/find",true).subscribe(x=>{  
            this.transformarCardView(x);
  
            //this.rows = data;
            //this.temp = JSON.parse(JSON.stringify(this.rows));
            
            this.totalLines = x['totalLines'];
            this.cd.markForCheck();
  
            if ( functions != null ){
              functions.forEach((fun:Function)=>{
                fun.call(this);
              });
            }
            this.itemsLoading = false;
            this.screenLoading = false;
            resolve(true);   
            
      },error=>{
        this.itemsLoading = false;
        this.screenLoading = false;
        throw error;
      },()=>{
        this.itemsLoading = false;
        this.screenLoading = false;
      });
    });
    
  }
  
  async refresh(currentPage:number, event?, functions?:Function[] ) {
    
    this.totalLines = -1;
    this.rows.next([]);
    this.temp.next([]);
    
    let condition:string = this.transformcondition(); 
     if ( condition != null ){
      
      if ( condition.indexOf("{") > -1 && condition.indexOf("}") > -1 ){
      
        this.dialogServices.openGenericDialog(PromptFilterViewComponent,{data:condition,lastFilter:this.lastFilter},async (data)=>{
            
            let newCondition = JSON.parse(data).expressao;
            this.lastFilter = JSON.parse(data).group;

            while ( ( this.totalLines > this.rows.getValue().length || this.totalLines == -1) && this.cancelPaginator == false){
              this.showPaginator = true;
              await this.apply(this.rows.getValue().length, event, null, newCondition, false);
            }
            
            this.setConfigFilter();
            this.saveUserConfig();
            this.cancelPaginator = false;
            this.showPaginator = false;

            //this.apply(currentPage,event,functions,newCondition);
        },()=>{
          this.screenLoading = false;
        })
      }else{
          
          while ( ( this.totalLines > this.rows.getValue().length || this.totalLines == -1) && this.cancelPaginator == false){

            this.showPaginator = true;
            await this.apply(this.rows.getValue().length, event, null, condition, false);
          }
          
          this.setConfigFilter();
          this.saveUserConfig();
          this.cancelPaginator = false;
          this.showPaginator = false;
          //this.apply(currentPage,event,functions,condition);
     }
    }else{
      this.screenLoading = false;
    }
  }


  open(){
      this.opened = true;
      this.height = "60%";
      this.heightFilter = "25%";
      this.expanded = true;
  }

  close(){
    this.opened = false;
     this.height = "75%";
     this.heightFilter = "10%";
     this.expanded = false;
  }

  
  async ngOnInit(){
      this.canInsert = this.ap.canInsert;
      this.canEdit = this.ap.canEdit;
      await this.loadTableStructure();
  }

  loadTableStructure(){
      return new Promise((resolve,reject)=>{

        let ob= {
          "entityName":this.tableName,
          "rows":1,
          "showPresentation":true,
          "showRelationshipData":false,
          "showRelationship":false,
          "fetchSize":1,
          "condition":'0=1'
      } 

        this.sub6 =  this.http.post(ob,"JsonBrokerServices/find",true).subscribe(x=>{  
          this.dataRowColumns = x['table_information'];
          resolve(true);
        },error=>{
            throw error;
        })
      });
  }

  ngAfterViewInit() {
      
      this.screenLoading = true;
      
      this.init = true;
      this.ucs.loadUserConfig(this.uas.user.iduser,this.tableName).subscribe(async response=>{
        
          await this.getFastFilter();
          
          if ( ObjectUtil.isNotEmpty(response['Mktpusercfg'])){
            if ( ObjectUtil.isNotEmpty(response['Mktpusercfg'][0])){
              if ( ObjectUtil.isNotEmpty( response['Mktpusercfg'][0]['FILTER'])){
                this.filters = JSON.parse(response['Mktpusercfg'][0]['FILTER']) as Filter[];
              }
              if ( ObjectUtil.isNotEmpty( response['Mktpusercfg'][0]['CONFIG'])){
                this.userConfig = JSON.parse(response['Mktpusercfg'][0]['CONFIG'])
                if ( ObjectUtil.isNotEmpty(this.userConfig)){
                    
                  this.ucs.loadActions(this.tableName).subscribe(responseAction=>{
                    this.actionList = responseAction['Mktpdicaction'];
                    
                    this.actionList = this.actionList.filter(data=> this.ap.checkActionPermission(data.IDACTION));
                    
                    if ( this.actionList.length > 0 ){
                      this.showAction = !this.showAction;
                    
                      this.actionList.forEach(data=>{
                        this.options.push({icon:data.ICON, desc:data.NAME, type:"action", action: data})
                      })
                      
                    }
                    this.cd.detectChanges();
                  });
  
                  if (this.userConfig.lastFastFilter != null && this.userConfig.lastFastFilter.length >0){
                      if ( this.fastFilter.length > 0 ){
                          for ( var lastff of this.userConfig.lastFastFilter ){
                              let filterff =this.fastFilter.find(d=>d.name == lastff.name);
                              if ( filterff != null ){
                                  filterff.checked = lastff.filter;
                              }
                          }
                      }
                  }
                  
                  if ( this.userConfig.lastFilter != null && this.userConfig.lastFilter.length > 0 ){
                    this.screenLoading = false;
                    let selected = (this.filters || []).filter(f => this.userConfig.lastFilter.indexOf(f.name) > -1);
                    this.filterSelect.setValue(selected);
                    this.refresh(0);
                  }else{
                    this.refresh(0);
                  }
                }else{
                  this.refresh(0);
                }
              }else{
                this.refresh(0);
              }
            }else{
              this.refresh(0);
            }
          }else{
            this.refresh(0);
          }
  
          if ( this.cardcustom != null ){
            //this.addComponent();
          }
  
          this.cd.detectChanges();
        
        
      },error=>{
        this.screenLoading = false;
        throw error;
      },()=>{
        //this.screenLoading = false;
        this.init = false;
      });


   }

   novo(event:Event){
      event.stopPropagation();
      event.preventDefault();

      this.open();
      this.showFilter = true;
      //this.filterViewComponent.clearAll();
      setTimeout(()=>{this.filterViewComponent.clearAll()},100);
      
   }

   transformcondition():string{
    
    let condition:string = "";

    let conditionFast = "";
    
    const selectedFilters: Filter[] = (this.filterSelect.value as Filter[]) || [];

    if ( selectedFilters.length > 0 ){
      let i:number = 0;
      selectedFilters.forEach(value=>{
          if ( i == 0 ){
            condition = condition + " " + value.expression;
          }else{
            condition = condition + " AND " + value.expression;
          }
          i++;
      });
    }else{
      condition = " 0=0 ";
    }

    if ( this.fastFilter!= null && this.fastFilter.length >0 ){
      this.fastFilter.forEach((filter,findex,farray)=>{
        if ( filter.checked.length > 0 ){
          let innerCondition = '';
          filter.checked.forEach((c,index,array)=>{
              let ff = filter.conditions.find(cond=>cond.name == c);
              if ( ff != null ){
                let ffcondition = filter.conditions.find(cond=>cond.name == c).condition;
                if ( filter.fieldName == null ){
                  if ( index == array.length - 1){
                    innerCondition = innerCondition + ` (${ffcondition} ) `
                  }else{
                    innerCondition = innerCondition + ` ( ${ffcondition} ) OR `
                  }
                }else{
                  if ( index == array.length - 1){
                    innerCondition = innerCondition + ` ( ${filter.fieldName}  = '${ffcondition}' ) `
                  }else{
                    innerCondition = innerCondition + ` ( ${filter.fieldName}  = '${ffcondition}' ) OR `
                  }
                }
                
              }
          });

          if ( innerCondition != null && innerCondition!=''){
            if ( findex == farray.length - 1){
              conditionFast = conditionFast + "("+innerCondition + ")";
            }else{
              conditionFast = conditionFast + "("+innerCondition + ")" + ' AND ';
            }
          }
        }
      });
    }
    if ( conditionFast!= null  && conditionFast!= '' ){
        condition = condition + ' AND ' +conditionFast;
    }
    
    return condition;
   }

   aplicar(event:Event){

      event.stopPropagation();
      event.preventDefault();
      this.cancelPaginator = false;
      this.refresh(0,null,[
                          
                        ]
                  );
      this.close();
      this.pageControl = [];
   }

   cancelar(event:Event){
      event.stopPropagation();
      event.preventDefault();
      if ( this.sub1!= null){
        this.sub1.unsubscribe();
      }
      
      this.showFilter=false
   }


   cancelarLoading(){
      this.cancelPaginator=true;
      if ( this.sub1!= null){
        this.sub1.unsubscribe();
      }
      this.showPaginator = false;
      
   }


   setConfigFilter(){

    let f:string[] = [];

    ((this.filterSelect.value as Filter[]) || []).forEach(value=>{
        f.push(value.name);
    });
    this.userConfig.lastFilter = f;

    if ( this.fastFilter!= null && this.fastFilter.length> 0 ){
      this.fastFilter.forEach(d=>{ 
          let ob = {
            name: d.name,
            filter: d.checked
          }

          // if ( this.userConfig.lastFastFilter == null ){
          //   this.userConfig.lastFastFilter = [ob];
          // }else{
          //   this.userConfig.lastFastFilter.push(ob);
          // }
          this.userConfig.lastFastFilter = [ob];
      });
    }

   }

   saveUserConfig(){
    
    return new Promise((resolve,reject)=>{
      let jsonDec:Object ={
        "entityName":"Mktpdic",
        "condition":`instancename='${this.tableName}'`
      };
      
      this.ucs.saveUserCfg(jsonDec,this.uas.user.iduser,this.filters,this.userConfig).then(me=>{
        
        this.cd.markForCheck();
        this.screenLoading = false;
        //this.snackBar.showSuccess("Filtro gravado com sucesso.");
        resolve(true);
      }, error=>{
        throw error;
      });
    });      
   }

   excluir(data){

      data.stopPropagation();
      data.preventDefault();

      // bug antigo: comparava filter.name com o id DOM do MatOption e removia o item errado
      ((this.filterSelect.value as Filter[]) || []).forEach(value=>{
        let index = this.filters.findIndex(filter=>filter.name == value.name);
        if ( index > -1 ){
          this.filters.splice(index,1);
        }
      });

      this.filterSelect.setValue([]);
      this.saveUserConfig();

   }

   saveFunction(data){

      let expression:string[] = this.filterViewComponent.fields;
      this.filterViewComponent.fields = [];
      
      let expressao = ObjectUtil.arrayStringToString(expression);
      if ( this.editing != null ){
        let index = this.filters.findIndex(c=>c.name == this.editing.name);
        this.filters[index].expression = expressao;
      }else{
        let name = data.name;
        let filter:Filter = {name:name, expression:expressao, lastfilter: '' };
        if ( this.filters == null || this.filters == undefined ){
          this.filters = [];
        }
        this.filters.push(filter);
      }
      this.filterViewComponent.fields = [];
      this.showFilter = false;
      this.filterViewComponent.filterForm.get('expressaoCtrl').setValue(null);    
      this.saveUserConfig().then(x=>{
        
      });
   }

   salvar(event:Event){
      event.stopPropagation();
      event.preventDefault();
      
      if ( this.filterViewComponent.fields.length == 0){
        this.snackBar.showError("Não existe nenhuma expressão informado no filtro.");
        return;
      }
      if ( this.editing != null ){
        this.saveFunction(null);
      }else{
        this.dialogServices.openGenericDialog(SalvarfiltroComponent,{nome:''},(data)=>{
          this.saveFunction(data);
          this.cd.detectChanges();
        });
      }
      
      

   }

   doInputFilter(value) {

    
    this.temp.next( this.rows.getValue().filter((data: CardView) => {
      //let title:boolean = data.title.toString().toLowerCase().indexOf(filterValue) !== -1;
      let field:boolean = false;

      if (  this.contextmenuColumn != null && this.contextmenuColumn != undefined ){
        let card = data.table.find(x=>x.columnName==this.contextmenuColumn);
        if ( card != undefined ){
          try{
            field =  card.value.toString().toLowerCase().indexOf(value.toLocaleLowerCase()) !== -1 
          }catch( exception){
            field = false;
          }
        }
      }
      return  field;
    }));

   }

   updateFilter(event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.inputValue = filterValue;
    if ( filterValue == null ){
      return;
    }

    
    if ( this.contextmenuColumn == null){
      this.snackBar.showError("Para buscar um campo, selecionar o campo na lista.");
      (event.target as HTMLInputElement).value = null;
      return;
    }
    
    this.doInputFilter(filterValue)
  }

  clickRow(row,event){
    this.cancelPaginator = true;
    this.rowContext.next(row)
  }

  onTableContextMenu(contextMenuEvent) {

    if (contextMenuEvent === 'null' || contextMenuEvent == undefined) {
      this.filtroStr = `Nenhum campo selecionado para filtro.`;
    } else {
      this.contextmenuColumn = contextMenuEvent['columnName'];
      let contextmenuColumnDesc = contextMenuEvent['descName'];
      this.filtroStr = `Campo ${contextmenuColumnDesc} selecionado para filtro.`;
    }
  }

  transformarCardView(x:any):CardView[]{

      let rows:[] =  x[this.tableName];
      let cards:CardView[] = [];
      this.dataRowColumns = x['table_information'];
      
      rows.forEach( row=>{
        let config = [];

        this.config.forEach( cf =>{
            let linha:columnsDef =  this.dataRowColumns.find(c=>c.COLUMNNAME === cf.columnName); 

            let data = {
              value: row[cf.columnName],
              columnName: cf.columnName,
              fontName: cf.fontName,
              fontSize: cf.fontSize,
              fontWeight: cf.fontWeight,
              row: cf.row,
              column: cf.column,
              type: linha !=null ? linha.DATATYPE : "",
              descName: cf.descName,
              fontColor: cf.fontColor,    
            }
            
            config.push(data);
          })

          let cardView:CardView = {pk:row[this.pk],title:row[this.title], image:row[this.img], table: config, linha:row, table_information: this.dataRowColumns, entityName: this.tableName}
          cards.push(cardView);

      })

      this.rows.next(this.rows.getValue().concat(cards));
      this.temp.next(this.temp.getValue().concat(cards));
      //this.temp.concat(cards);
      if ( this.inputValue != null ){
        this.doInputFilter(this.inputValue);
      }
      
      //return this.rows.concat(cards);
      return null;
  }

  selectedFilter(evento,col){
    
    
    let index = this.fieldSelected.findIndex(d=>d == col.name);
    
    if ( index > -1 ){
      this.fieldSelected.splice(index,1);
    }else{
      if ( this.fieldSelected.length > 0){
        this.fieldSelected = [];
      }
      this.fieldSelected.push(col.name);
    }
    
    if ( this.fieldSelected.length > 0 ){
      this.inputEnable  = true;
    }else{
      this.inputEnable = false;
    }
    this.contextmenuColumn = col.name;
    this.filtroStr = `Campo ${col.desc} selecionado para filtro.`;
  }

  getFastFilter(){
    return new Promise( (resolve,reject)=>{
      let ob = {
        "entityName":"Mktpcontractpref",
        "sql":`SELECT A.NAME,A.TEXT
              FROM MKTPCONTRACTPREF A 
              WHERE A.CODECONTRACT IN (${this.uas.getContracts()})
              AND A.CODEMKTP=0
              AND A.NAME IN ( 'mktp.${this.tableName.toLowerCase()}.fastfilter','mktp.${this.tableName.toLowerCase()}.fastfilter.condition')
              UNION ALL 
              SELECT A.NAME,A.TEXT
              FROM MKTPPREF A
              WHERE A.NAME IN ( 'mktp.${this.tableName.toLowerCase()}.fastfilter','mktp.${this.tableName.toLowerCase()}.fastfilter.condition')`
      }
       
      this.sub4 = this.http.post(ob, 'JsonBrokerServices/findnative', false, true, true).subscribe(async con => {

        if (ObjectUtil.isNotEmpty(con['SQL'])) {
            let results:object[] = con['SQL'];;
            
            if (results) {
              let jsonFF = results.find(d=>d['NAME']=='mktp.'+this.tableName.toLowerCase()+'.fastfilter');
              
              if ( jsonFF != null ){
                this.fastFilter = JSON.parse(jsonFF['TEXT']) as FastFilter[];

                let jsonFFCondition = results.find(d=>d['NAME']=='mktp.'+this.tableName.toLowerCase()+'.fastfilter.condition');
                if ( jsonFFCondition != null ){
                    let sqls = JSON.parse(jsonFFCondition['TEXT']);
                    if ( sqls != null ){
                      
                      this.executeCondition(sqls).then(a=>{
                        resolve(true);
                      });
                    }
                }

              }
            
          }
        }else{
          resolve(true);
        }
        
        })
      });
  }

  async executeCondition(sqls){

    for ( var s of sqls ){
      let zs = 0;
      let sql =s['query'];
      
      await this.processarCondicao(sql).then((conditions:object)=>{
        if ( conditions != null ){
          
          let conditionExpression = conditions;
          this.fastFilter[zs].conditions = conditionExpression['SQL'];
        }
        zs++;
      });
    }
  }

  copyConfiguration(){
    
    this.dialogServices.openGenericDialog(CopyFormConfigurationComponent,{
        entityName:this.tableName, 
        userConfig:this.userConfig, 
        filter: this.filters
      },(retorno)=>{
        this.snackBar.showSuccess("Configurações copiadas com sucesso.");
    },()=>{
        this.snackBar.showInformation("Processo cancelado.")
    })
}

  processarCondicao( sql:string){
    return new Promise((resolve,reject)=>{
       
       let ob = {
        'expressao': "executeSqlJSON(\""+sql+"\",\"SQL\")",
        'novo':true,
        'codecontract':0,
        'codecompany': 0,
        'codemktp':0,
        'values':[{
            'key':'@CONTRACTS',
            'value':this.uas.getContracts()
        }]
        }
        
        this.sub3 = this.http.post(ob, 'FormulaServices/test', false, true, false).subscribe(data => {
        
            if (ObjectUtil.isNotEmpty(data['resultado'])) {
                resolve(JSON.parse(data['resultado'] as string));
            }
        }, error => {
            reject(error);
            throw error;
        });

    });
  }


  editar(data){
    data.stopPropagation();
    data.preventDefault();

    const selected: Filter[] = (this.filterSelect.value as Filter[]) || [];

    if ( selected.length != 1 ){
      this.snackBar.showError("Para editar um filtro deve-se escolher apenas 1 registro.");
      return;
    }

    this.editing = this.filters.find(filter=>filter.name == selected[0].name);
    this.open();
    this.showFilter = true;
  }
  
}

  
